export default {
    dependencies: ['$element'],
    callable(ele) {
        ele.addEventListener('keydown', handleKeydown);

        function handleKeydown(event) {
            // Not sure this is a great idea, it will probably break in some cases,
            // e.g. if someone moves the focus outline by some other means that tabbing,
            // but let's try it for now.
            if (event.keyCode === 9 /* Tab */) {
                ele.classList.remove('no-focus-ring');
                ele.removeEventListener('keydown', handleKeydown);
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/focusStyling.js